<template>
<div class="home-tabs">
    <!-- <div class="arrowMore">
        <img src="@/assets/img/Group738@2x.png" alt="">
    </div> -->
    <van-tabs v-model="activeTabs" @change="changeTabFun">
        <!--<van-tab title="关注" name="0"></van-tab>-->
        <!--<van-tab title="推荐" name="1"></van-tab>-->
        <!--<van-tab title="资讯" name="3-0"></van-tab>-->
        <!--&lt;!&ndash; <van-tab title="拍卖" name="2">-->
        <!--</van-tab> &ndash;&gt;-->
        <!--<van-tab title="专题" name="3"></van-tab>-->
        <!--<van-tab title="行情" name="4"></van-tab>-->

        <van-tab v-for="tab in tabs" :key="tab.title" :title="tab.title" :name="tab.sign"></van-tab>
    </van-tabs>
</div>
</template>

<script>
import {
    getHomeTabs
} from '@/api/index'
import {
    scMdFunc
} from "@/assets/js/scData";
export default {
    name: 'HomeTabs',
    props: {
        activeTab: {
            type: String,
            default: '2-0'
        }
    },
    watch: {
        activeTab: {
            immediate: true,
            handler(val) {
                this.activeTabs = val
            }
        },
        '$route' (to, from) {
                this.$router.go(0);
        }
    },
    data() {
        return {
            activeTabs: '1',
            tabs: []
        }
    },
    methods: {
        changeTabFun(name) {
            let [type, id] = name.split('-')
            switch (type) {
                case '1':
                    scMdFunc('allClick', {
                        cur_page: '10',
                        cur_moudle: '0-2',
                        cur_button: '0-2-1',
                    })
                    this.$router.push({
                        path: '/follow'
                    })

                    break
                case '2':
                    scMdFunc('allClick', {
                        cur_page: '10',
                        cur_moudle: '0-2',
                        cur_button: '0-2-2',
                    })
                    this.$router.push({
                        path: '/'
                    })

                    break
                case '3':
                    this.$router.push({
                        path: '/newsList'
                    })

                    break
                case '4':
                    scMdFunc('allClick', {
                        cur_page: '10',
                        cur_moudle: '0-2',
                        cur_button: '0-2-3',
                    })
                    this.$router.push({
                        path: '/topics'
                    })
                    break
                case '5':
                    scMdFunc('allClick', {
                         cur_page: '10',
                        cur_moudle: '0-2',
                        cur_button: '0-2-4',
                    })
                    this.$router.push({
                        path: '/quotations'
                    })
                    break
                case '7':
                    scMdFunc('allClick', {
                         cur_page: '10',
                        cur_moudle: '0-2',
                        cur_button: '0-2-0'+id,
                    })
                    this.$router.push({
                        path: '/recommendTopic/' + id
                    })


                    break
                default:
                    return ''
            }
        }
    },
    mounted() {
        getHomeTabs().then(res => {
            if (res.code === 0) {
                this.tabs = res.data.top_menu.map(item => {
                    return {
                        ...item,
                        sign: `${item.button_type}-${item.source_id}`
                    }
                })

                this.tabs.splice((this.tabs.length-1), 0, {
                    title: '资讯',
                    sign: '3-0'
                })
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.home-tabs {
    width: 100%;
    position: relative;
    .arrowMore{
        position: absolute;
        z-index: 5;
        top: 10px;
        left: 8px;
        img{
            width: 0.8rem;
            height: 0.8rem;
        }
    }
    /deep/ .van-tab {
        flex: none;
        margin: 0 8px;

        .van-tab__text {
            display: block;
            max-width: 8rem;
            font-size: 0.7rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }

    /deep/ .van-tab--active {
        font-weight: bold;
        font-size: 0.7rem;
        color: #000000;
    }

    /deep/ .van-tabs__line {
        background: linear-gradient(90deg, #18A974 0%, rgba(24, 169, 116, 0) 100%);
        width: 31px;
        height: 4px;
        bottom: 30px;
        border-radius: 0;
    }

}
</style>
